import DownloadsCard from './DownloadsCard';

export default DownloadsCard;
